<template>
  <div>
    <v-sheet class="d-flex justify-center align-center">
      <v-row no-gutters>
        <v-col cols="12" xs="12" sm="7" class="d-flex flex-column pl-10">
          <p
            class="font-style mb-1 ml-1"
            :style="fileError ? { color: 'red' } : {}"
          >
            {{ "Image Cover" }}
          </p>
          <div class="d-flex mt-1 ">
            <v-card
              width="270"
              height="200"
              style="border: 2px dashed #c0c0c0;
                   box-shadow: unset;
                   background: #f8f8f8 0% 0% no-repeat padding-box;
                  "
              @click="$refs.ImgFile.click()"
              @dragover.prevent
              @dragenter.prevent
              @drop.prevent="DropImageFile($event)"
            >
              <v-img
                :src="src_Of_ImageFile"
                @click="$refs.ImgFile.click()"
                @mouseover="
                  src_Of_ImageFile
                    ? (showEditImgTool = true)
                    : (showEditImgTool = false)
                "
                @mouseleave="
                  src_Of_ImageFile
                    ? (showEditImgTool = false)
                    : (showEditImgTool = false)
                "
                :style="fileError ? { border: '1px solid #FA5252' } : {}"
                width="200"
                height="155"
                style="border-radius: 8px !important"
                class="mx-auto center mt-4"
                v-if="src_Of_ImageFile"
              >
                <v-card-title
                  v-if="showEditImgTool"
                  style="left: 15%; top: 15%; position: absolute"
                >
                  <v-list
                    class="d-flex flex-column align-start"
                    style="padding: 0; border-radius: 8px"
                  >
                    <v-list-item class="list-item-padding">
                      <v-btn
                        color="#424242"
                        style="font-size: 14px; width: 100px"
                        text
                        class="text-capitalize"
                        @click.stop="ImagePreview = true"
                      >
                        <v-icon left>mdi-eye-outline</v-icon>
                        {{ $t("preview") }}
                      </v-btn>
                    </v-list-item>

                    <v-list-item class="list-item-padding">
                      <v-btn
                        color="#FF6060"
                        style="font-size: 14px; width: 100px"
                        text
                        class="text-capitalize"
                        @click.stop="
                          (src_Of_ImageFile = null),
                            (ImgFile = null),
                            (NameOfImageFile = null)
                        "
                      >
                        <v-icon left>mdi-delete-outline</v-icon>
                        {{ $t("delete") }}
                      </v-btn>
                    </v-list-item>
                  </v-list>
                </v-card-title>
              </v-img>
              <v-img
                v-if="!src_Of_ImageFile"
                src="@/assets/image_loader.png"
                width="64"
                height="52"
                class="mx-auto center"
                style="margin-top: 2.5rem"
                @click="$refs.ImgFile.click()"
              ></v-img>
              <input
                type="file"
                class="d-none"
                ref="ImgFile"
                accept="image/*"
                @change="UploadImageFile($event, 1)"
              />
              <p
                v-show="!src_Of_ImageFile"
                class="text-center mt-3"
                style="
                            color: #424242;
                            font-size: 14px;
                            opacity: 0.6;
                            margin-bottom: 0;
                          "
              >
                {{ "Drag & Drop your file here" }}
              </p>
              <p
                v-show="!src_Of_ImageFile"
                class="text-center"
                style="color: #424242; font-size: 14px; opacity: 0.6"
              >
                {{ "Or Browse File" }} JPG"
              </p>
            </v-card>
          </div>
        </v-col>
        <v-col
          cols="12"
          xs="12"
          sm="5"
          class="d-flex justify-top flex-column pl-2 pt-9"
        >
          <div class="d-flex flex-column">
            <v-btn
              color="#A6CC39"
              style="
                width: 150px;
                border-radius: 8px;
                height: 40px;
                font-size: 16px !important;"
              class="text-capitalize white--text btn_hover_effect"
              @click="$refs.ImgFile.click()"
            >
              <v-icon class="mr-1">mdi-plus-box-outline</v-icon>
              {{ "Add Cover" }}
            </v-btn>
            <p class="mt-3 pr-3" style="color: #777777; font-size: 12px">
              {{ "Recommend Format : .PNG .JPG, Resolution = 800x450 Pixel" }}
            </p>
          </div>
        </v-col>
      </v-row>
    </v-sheet>

    <!-- copper dialog -->
    <v-dialog
      v-model="dialogCrop"
      width="1000px"
      height="800px"
      overflow="hidden"
    >
      <v-card class="rounded-lg" overflow="hidden">
        <v-card-title
          class="white--text pb-4"
          style="background-color: #a6cc39; font-size: 30px"
          >Crop Image</v-card-title
        >
        <v-card-text
          class="pt-12"
          style="height: 550px; padding-left: 4rem; padding-right: 4rem"
        >
          <vue-cropper
            ref="cropper"
            :img="CropperOption.img"
            :output-size="CropperOption.size"
            :output-type="CropperOption.outputType"
            :info="true"
            :full="CropperOption.full"
            :can-move="CropperOption.canMove"
            :can-move-box="CropperOption.canMoveBox"
            :fixed-box="CropperOption.fixedBox"
            :original="CropperOption.original"
            :auto-crop="CropperOption.autoCrop"
            :auto-crop-width="CropperOption.autoCropWidth"
            :auto-crop-height="CropperOption.autoCropHeight"
            :center-box="CropperOption.centerBox"
            :high="CropperOption.high"
          ></vue-cropper>
        </v-card-text>
        <v-card-actions class="mt-3 pb-4" style="margin-right: 50px">
          <v-spacer></v-spacer>
          <v-btn
            class="text-capitalize btn-font-s16"
            style="
              border: 1px solid #c0c0c0;
              border-radius: 8px;
              color: #424242;
            "
            text
            @click="CancelCrop()"
            >{{ $t("cancel") }}</v-btn
          >
          <v-btn
            class="text-capitalize btn-font-s16 btn_hover_effect"
            style="
              font-size: 16px;
              border-radius: 8px;
              background-color: #a6cc39 !important;
              color: #ffffff !important;
            "
            width="110"
            @click="CropImage()"
            >{{ $t("submit") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- previewing image -->
    <v-dialog
      v-model="ImagePreview"
      persistent
      width="800px"
      height="800px"
      overflow="hidden"
      content-class="elevation-0 preview_class"
    >
      <v-card overflow="hidden" color="transparent">
        <v-card-title style="padding-right: 0 !important">
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="ImagePreview = false"
            color="#FFFFFF"
            style="border-radius: 8px !important; border: 1px solid #ffffff30"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-img
          width="800px"
          height="500px"
          style="border-radius: 8px; margin: auto"
          :src="src_Of_ImageFile"
        ></v-img>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { VueCropper } from "vue-cropper";

export default {
  components: {
    VueCropper
  },
  props: {
    fileError: {
      type: Boolean,
      default: false
    },
    editImageSrc: {
      type: String,
      default: null
    }
  },
  watch: {
    editImageSrc: {
      handler(newValue) {
        if (newValue) {
          this.src_Of_ImageFile = newValue;
        } else {
          this.src_Of_ImageFile = null;
        }
      },
      deep: true, // Watches nested properties of EditItem
      immediate: true // Trigger immediately if you want to run on initial load
    }
  },

  data: () => ({
    imageInfo: {
      file: "file",
      name: "name"
    },
    NameOfImageFile: null,
    courseImgCrop: false,
    CropperOption: {
      img: "",
      size: 1,
      full: false,
      outputType: "png",
      canMove: true,
      fixedBox: true,
      original: false,
      canMoveBox: false,
      autoCrop: true,
      autoCropWidth: 800,
      autoCropHeight: 450,
      centerBox: false,
      high: true
    },
    dialogCrop: false,
    showEditImgTool: false,
    src_Of_ImageFile: null,
    ImagePreview: false,
    //fileError: false,
    ImgFile: null
  }),
  mounted() {},

  methods: {
    async getFile(e) {
      console.log("get file: ", e);
      this.src_Of_ImageFile = e;
      //this.CancelCrop();
      this.showEditImgTool = false;
    },

    async GetCoverImgFile(e) {
      this.src_Of_ImageFile = e;
      this.imageInfo.file = e;
      this.imageInfo.name = this.NameOfImageFile;
      this.showEditImgTool = false;
      this.courseImgCrop = false; //set false after cropping image
      console.log("crop & upload=>", this.imageInfo);
      // this.CancelCrop();
    },

    CropImage() {
      this.$refs.cropper.getCropData(data => {
        if (this.courseImgCrop) {
          this.GetCoverImgFile(data);
        } else {
          //for edit i guess
          this.getFile(data);
        }
        this.dialogCrop = false;
        this.$emit("GetImageData", this.imageInfo);
      });
    },
    CancelCrop() {
      this.dialogCrop = false;
      this.imageInfo = { file: null, name: null };
      (this.ImgFile = null), (this.NameOfImageFile = null);
      this.src_Of_ImageFile = null;
    },
    DropImageFile(e) {
      let file = e.dataTransfer.files[0];
      if (!/(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(file.name)) {
        alert("Please choose image!");
        return false;
      }

      this.NameOfImageFile = file.name;
      this.courseImgCrop = true;
      let reader = new FileReader();
      reader.onload = f => {
        let src;
        if (typeof f.target.result === "object") {
          src = window.URL.createObjectURL(new Blob([f.target.result]));
        } else {
          src = f.target.result;
        }
        this.CropperOption.img = src;
        this.dialogCrop = true;
      };
      reader.readAsArrayBuffer(file);
    },

    UploadImageFile(e, num) {
      let self = this;
      let file = e.target.files[0];
      if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
        alert("Please choose image!");
        return false;
      }
      self.NameOfImageFile = file.name;
      self.courseImgCrop = true;
      let reader = new FileReader();
      reader.onload = function(f) {
        let data;
        if (typeof f.target.result === "object") {
          data = window.URL.createObjectURL(new Blob([f.target.result]));
        } else {
          data = f.target.result;
        }
        if (num === 1) {
          self.CropperOption.img = data;
          self.dialogCrop = true;
        }
      };
      reader.readAsArrayBuffer(file);
    }
  }
};
</script>

<style scoped>
::v-deep .font-style {
  font-size: 16px !important;
  color: #4d4f5c;
}
</style>
